import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';


import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_loanrequests from './create_newaccounts';

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function Employee_daysummarylist(){

    

    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const branch_id=sessionStorage.getItem("branchId00");

 /* PAGE VARIABLES */


 
{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
{/* const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 */}





//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);



 //Error Variable
 const[errorvar,seterrorvar] = useState();


//FILTER VARIABLES
//filter_val
const[filterval,setfilterval]=useState(0);
const[filter_status,setfilter_status]=useState();const updatefilter_status = (event) => { setfilter_status(event.target.value);}; const[filter_status_er,setfilter_status_er]=useState();
const[filter_start_date,setfilter_start_date]=useState('1970-01-01');const updatefilter_start_date = (event) => { setfilter_start_date(event.target.value);}; const[filter_start_date_er,setfilter_start_date_er]=useState();
const[filter_end_date,setfilter_end_date]=useState('2100-12-12');const updatefilter_end_date = (event) => { setfilter_end_date(event.target.value);}; const[filter_end_date_er,setfilter_end_date_er]=useState();



 
//Variables
const[data,setData] = useState([]);//SetData Variable


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


 useEffect(()=>{
   
  getData();
  
  },[])
 





//******************* GET LOAN APPLICATIONS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("crm-employee-get-day-summary-list", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,
  
   //Filters
   'Filter_val' :filterval,
   'Filter_status' :filter_status,
   'Filter_start_date' : moment(filter_start_date).format('YYYY-MM-DD'),
   'Filter_end_date' :moment(filter_end_date).format('YYYY-MM-DD'),

   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){

    setfilter_status_er(response.data.validatorerror.Filter_status);
    setfilter_start_date_er(response.data.validatorerror.Filter_start_date);
    setfilter_end_date_er(response.data.validatorerror.Filter_end_date);
    seterrorvar("Validation error!");

  }

  //Data Violation
  if(response.data.error==102){ 
  
     //Setting Filter Violation Errors
     setfilter_status_er(response.data.filter_status_er);
     setfilter_start_date_er(response.data.filter_start_date_er);
     setfilter_end_date_er(response.data.filter_end_date_er);
     seterrorvar("Violation Error");


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET LOAN APPLICATIONS DATA FUNCTION END  ********************//


 

//******************* GET EXCEL DATA FUNCTION START  ********************//
function getexcelData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("crm-employee-get-day-summary-list-inexcel", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,
  
   //Filters
   'Filter_val' :filterval,
   'Filter_status' :filter_status,
   'Filter_start_date' : moment(filter_start_date).format('YYYY-MM-DD'),
   'Filter_end_date' :moment(filter_end_date).format('YYYY-MM-DD'),

   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
  //Setting Data
  const exceldata =response.data.data;
   
  // Convert JSON data to Excel worksheet
  const worksheet = XLSX.utils.json_to_sheet(exceldata);
  
  // Create a new workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
  // Convert the workbook to a binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  
  // Create a Blob from the binary data and trigger a download
  const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(excel_data, "data.xlsx");
 }
 //Cannot Fetch Data
 else{
   seterrorvar("Cannot Download Excel File !");
 }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET EXCEL DATA FUNCTION END  ********************//


 
return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Employee Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">


             


          <div className="row">
              <div className="col-12 grid-margin create-form" id="create-form">
             {/*} <Create_cash /> */}
              </div>
          </div>


            <div className="page-header flex-wrap">
            <div className="header-left"></div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">EMPLOYEE PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">DAY SUMMARIES</p>
                  </a>
                </div>
            
              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

            

              {/* CASH TRANSACTIONS TABLE SECTION START */}
                  
             <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Day Summaries</h4>
                    <p className="card-description">view your day summaries from here
                    </p>

                    <code>{error_msg}</code>

{/* FILTER SECTION START */}
<hr/>
   <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
   <div class="d-flex justify-content-between">
   <div>
   <h4 style={{padding:'1rem'}}>Filters</h4>
  </div>
  <div>

  <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
  <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
  </button>
  </div>
  </div>

<div class="row">
<div class="col-md-4">
 <div class="form-group row">
   <label class="col-sm-4 col-form-label">Status</label>
   <div class="col-sm-8">
     <select class="form-control" placeholder="SCH1234567" id="filter_status" value={filter_status} onChange={updatefilter_status} >
     <option value="">All</option>
     <option value="under review">under review</option>
     <option value="approved">approved</option>
     </select>
     <code>{filter_status_er}</code>
   </div>
 </div>
</div>
 <div class="col-md-4">
<div class="form-group row">
<label class="col-sm-4 col-form-label">Start Date</label>
<div class="col-sm-8">
  <input type="date" class="form-control" placeholder="" id="filter_start_date" value={filter_start_date} onChange={updatefilter_start_date}  />
  <code>{filter_start_date_er}</code>
</div>
</div>
</div>
<div class="col-md-4">
<div class="form-group row">
<label class="col-sm-4 col-form-label">End Date</label>
<div class="col-sm-8">
  <input type="date" class="form-control" id="filter_end_date" value={filter_end_date} onChange={updatefilter_end_date}  />
  <code>{filter_end_date_er}</code>
</div>
</div>
</div>
 <div class="col-md-4">
   <button class="btn btn-primary" onClick={()=>{ setfilterval(1); getData(); }}>Apply Filters</button>
 </div>
<br/><br/>


</div>


   <hr/>                  
   </div> 
   
 {/*}   FILTER SECTION END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                        {/*}  <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button> */}
                      
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>


                    <div className="table-responsive"  id="invoice" ref={componentRef}>
                      <table className="table table-hover table-bordered">
                        <thead>
                          <tr >
                            <th><b>#</b></th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Date</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Day</th>
                            <th style={{fontWeight:"bold"}} hidden={cd_col1_val==1} >Opening Balance</th>
                            <th style={{fontWeight:"bold"}} hidden={cd_col1_val==1} >Cash Opening Balance</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Cash Closing Balance</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Closing Balance</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1} >Status</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col9_val==1} >Updated At</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1} >View</th> 
                          </tr>
                        </thead>
                        <tbody>
                      
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                          <tr key={ind}>
                          <td>{ind + 1}</td>
                          <td>{curElm.Date}</td>
                          <td>{curElm.Day}</td>
                          <td>{curElm.Opening_balance}</td>
                          <td>{curElm.Cash_opening_balance}</td> 
                          <td>{curElm.Cash_closing_balance}</td>
                          <td>{curElm.Closing_balance}</td>
                          <td> 
                            <label className="badge badge-warning" hidden={(curElm.Summary_status=="approved")}>under review</label>
                            <label className="badge badge-success" hidden={(curElm.Summary_status=="under review")}>approved</label>
                          </td>
                         {/* <td>Sohan (EMP ID: 82222)</td> */}
                          <td>{curElm.Date_updated} ({curElm.Time_updated})</td>
                         <td><button className="btn btn-primary" onClick={()=>{
                            //Edit Redirect
                            sessionStorage.setItem("EditId00",curElm.Sn);
                            window.location.replace("/employee-dashboard-daysummary")}}
                          >view</button></td>
                        </tr>
                        </>
                         )
                         }
                       
                             )
                         }
                      
                   
                          
                         
                        </tbody>
                      </table>
                    </div>
                    
                    {/* PAGINATION SECTION START */}
                    <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}
                  </div>
                </div>
              </div>

            {/* CASH TRANSACTIONS TABLE SECTION END */}

            <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>

            <br/><br/><br/>

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Employee_daysummarylist;